import React, { memo } from 'react';
import { Close } from '@mui/icons-material';
import CancelIcon from '@mui/icons-material/Cancel';
import { SelectDeProdutos } from './SelectDeProdutos';
import { IProduto } from '../../../shared/services/api/permissoes/PermissoesService';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, styled, Typography } from '@gvdasa/react-components';


export interface SimpleDialogProps {
  open: boolean
  onClose: (value: string) => void
  selectedValue: string
  produtos: IProduto[]
  lista: string[]
  setPesquisar: React.Dispatch<React.SetStateAction<string>>
  setListaMultiplaDeProdutos: React.Dispatch<React.SetStateAction<string[]>>
  listaFiltrada: string[]
  setListaFiltrada: (value: React.SetStateAction<string[]>) => void
  setLista: React.Dispatch<React.SetStateAction<string[]>>

}

export const ModalDeFiltro: React.FC<SimpleDialogProps> = memo(({
  open,
  onClose,
  selectedValue,
  produtos,
  lista,
  setListaMultiplaDeProdutos,
  setListaFiltrada,
  listaFiltrada,
  setLista
}) => {

  const handleClose = () => {
    onClose(selectedValue);
  };


  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(2),
    },
  }));

  interface DialogTitleProps {
    id: string;
    children?: React.ReactNode;
    onClose: () => void;
  }


  const BootstrapDialogTitle = (props: DialogTitleProps) => {
    const { children, onClose, ...other } = props;
    return (
      <>
        <DialogTitle style={{ margin: 0, padding: '20px' }} {...other}>
          {children}
          {onClose ? (
            <CancelIcon
              aria-label="close"
              onClick={onClose}
              style={{
                position: 'absolute',
                right: 8,
                top: 23,
                color: '#018781',
                cursor: 'pointer',
              }}
            >
              <Close />
            </CancelIcon>
          ) : null}
        </DialogTitle>
      </>
    );
  };


  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      disableEscapeKeyDown
    >
      <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
        <Typography color='primary' sx={{ fontSize: '1.3rem' }} fontWeight={500} >Filtros</Typography>
      </BootstrapDialogTitle >
      <DialogContent dividers style={{ width: '25rem', padding: '1.5rem' }}>
        <SelectDeProdutos
          MenuProps={MenuProps}
          produtos={produtos}
          lista={lista}
          listaFiltrada={listaFiltrada}
        />

      </DialogContent>
      <DialogActions sx={{ display: 'flex', justifyContent: 'space-around' }}>
        <Button
          variant='outlined'
          color='primary'
          size='medium'
          sx={{ width: '9.3rem' }}
          onClick={() => {
            setListaMultiplaDeProdutos([])
            setListaFiltrada([])
            setLista([])
          }}>Limpar</Button>
        <Button
          variant='contained'
          color='primary'
          size='medium'
          sx={{ width: '9.3rem' }}
          disableElevation
          onClick={() => {
            setListaMultiplaDeProdutos(lista)
            handleClose();
          }}>Filtrar</Button>
      </DialogActions>
    </BootstrapDialog>
  );
});